// client/src/components/Admin/InstitutionsReviCmp/InstitutionsReviTable.js
//
// Tabla AntD del tab Instituciones del panel admin /admin/revi.

import React from "react";
import { Table, Tag, Avatar, Space, Button, Popconfirm, Tooltip } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  StopOutlined,
  BankOutlined,
} from "@ant-design/icons";

function partnerLabel(partner) {
  if (!partner || typeof partner === "string") return partner || "—";
  const name = `${partner.firstname || ""} ${partner.lastname || ""}`.trim();
  return name || partner.email || "—";
}

function planLabel(plan) {
  if (!plan) return <Tag>Sin plan</Tag>;
  if (typeof plan === "string") return plan;
  return <Tag color="blue">{plan.title}</Tag>;
}

export function InstitutionsReviTable({
  items,
  loading,
  page,
  pageSize,
  total,
  onPageChange,
  onEdit,
  onToggleActive,
  onDelete,
}) {
  const columns = [
    {
      title: "Centro",
      dataIndex: "institutionName",
      key: "institutionName",
      render: (text, row) => (
        <Space>
          <Avatar
            src={row.avatar || undefined}
            icon={!row.avatar ? <BankOutlined /> : undefined}
          />
          <div>
            <div style={{ fontWeight: 600 }}>{text}</div>
            <div style={{ fontSize: 12, color: "#888" }}>{row.email}</div>
          </div>
        </Space>
      ),
    },
    {
      title: "Partner",
      dataIndex: "partner",
      key: "partner",
      render: partnerLabel,
    },
    {
      title: "Plan",
      dataIndex: "planEduca",
      key: "planEduca",
      render: planLabel,
    },
    {
      title: "Licencias (P / T)",
      key: "licencias",
      render: (_, row) => `${row.pacientesN || 0} / ${row.terapeutasN || 0}`,
    },
    {
      title: "Activa",
      dataIndex: "active",
      key: "active",
      render: (active) =>
        active ? <Tag color="green">Si</Tag> : <Tag color="default">No</Tag>,
    },
    {
      title: "Acciones",
      key: "actions",
      width: 160,
      render: (_, row) => (
        <Space>
          <Tooltip title="Editar">
            <Button
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEdit(row)}
            />
          </Tooltip>
          <Tooltip title={row.active ? "Desactivar" : "Activar"}>
            <Button
              size="small"
              icon={row.active ? <StopOutlined /> : <CheckCircleOutlined />}
              onClick={() => onToggleActive(row, !row.active)}
            />
          </Tooltip>
          <Popconfirm
            title="Eliminar institucion"
            description="Borrara la institucion, su usuario de acceso y el avatar. Esta accion no se puede deshacer."
            okText="Eliminar"
            okButtonProps={{ danger: true }}
            cancelText="Cancelar"
            onConfirm={() => onDelete(row)}
          >
            <Tooltip title="Eliminar">
              <Button size="small" danger icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      rowKey="_id"
      columns={columns}
      dataSource={items}
      loading={loading}
      pagination={{
        current: page,
        pageSize,
        total,
        showSizeChanger: false,
        onChange: onPageChange,
      }}
    />
  );
}
